import React, { useState } from "react";
import close from "common-ui-components/components/icons/close.svg";
import TableManager from "common-ui-components/components/table-manager";
import styles from "./AffectedDevices.module.css";
import ManagedDevice from "../../../../common/managed-device/ManagedDevice";
import API from "common-ui-components/components/utils/API";
import { notify } from "common-ui-components/components/notification/Notification";
import {
  Success,
  Failure,
} from "common-ui-components/components/notification/templates";
import Message from "common-ui-components/components/messager/Message";
const columns = [
  {
    title: "Device Name",
    accessor: "deviceName",
    WrapperComponent: ManagedDevice,
  },
  { title: "OS Name", accessor: "osName" },
  { title: "Platform", accessor: "platform" },
  //   { title: "Status", accessor: "agentStatus" },
];

const AffectedDevices = ({ softwareId, softwareName, softwareVersionId }) => {
  const [tableKey, setTableKey] = useState(0);
  const [isRemediating, setIsRemediating] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [pendingDeviceIds, setPendingDeviceIds] = useState([]);

  const handleUninstallAll = (selectedRows) => {
    // guard against double-clicks / re-entrancy while a call is already in flight,
    // since there's no disabled prop exposed on actionsConfig to rely on
    if (isRemediating) return;

    const validDeviceIds = (selectedRows || [])
      .map((row) => row?.deviceId ?? row?.id)
      .filter((id) => id !== undefined && id !== null);

    if (!validDeviceIds.length) {
      notify(<Failure>Select at least one device.</Failure>);
      return;
    }

    setPendingDeviceIds(validDeviceIds);
    setIsConfirmOpen(true);
  };

  const closeConfirm = () => {
    if (isRemediating) return; // don't allow closing mid-request
    setIsConfirmOpen(false);
    setPendingDeviceIds([]);
  };

  const confirmUninstall = async () => {
    if (isRemediating) return;

    setIsRemediating(true);
    try {
      const response = await API.post(`/softwares/uninstall`, {
        deviceIds: pendingDeviceIds,
        softwareVersionIds: softwareVersionId,
      });

      if (response?.status?.code === 200) {
        notify(
          <Success>
            {response?.status?.message || "Uninstall initiated successfully"}
          </Success>,
        );
        setTableKey((prev) => prev + 1); // refresh the device table
      } else {
        notify(
          <Failure>
            {response?.status?.message || "Failed to uninstall software."}
          </Failure>,
        );
      }
    } catch (error) {
      console.error("Error while uninstalling software:", error);
      notify(<Failure>Failed to uninstall software.</Failure>);
    } finally {
      setIsRemediating(false);
      setIsConfirmOpen(false);
      setPendingDeviceIds([]);
    }
  };

  const actionsConfigList = [
    {
      label: "Uninstall",
      props: {
        onClick: handleUninstallAll,
      },
      variant: "primary",
      disableOnNoSelection: true,
      loading: isRemediating,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <h3 className={styles.title}>Affected endpoints</h3>
          <p className={styles.subtitle}>High Risk Software · {softwareName}</p>
        </div>
      </div>

      <div className={styles.list}>
        <TableManager
          selectable
          key={`${softwareId}-${tableKey}`}
          columns={columns}
          url={`vulnerabilities/software/${softwareId}/devices`}
          headingText="Total Devices : "
          contrastRow={false}
          exportNeeded={false}
          searchControlNeeded={false}
          containerProps={{
            style: {
              border: "none",
            },
          }}
          headerProps={{
            style: {
              background: "none",
            },
          }}
          paginationContainerProps={{
            style: {
              background: "none",
            },
          }}
          actionsConfig={actionsConfigList}
        />
      </div>

      <Message
        isOpen={isConfirmOpen}
        onClose={closeConfirm}
        onCancel={closeConfirm}
        title="Uninstall software"
        description={`Are you sure you want to uninstall ${softwareName} from ${pendingDeviceIds.length} selected device${pendingDeviceIds.length === 1 ? "" : "s"}?`}
        confirmType="delete"
        confirmMessage="Uninstall"
        onConfirm={confirmUninstall}
        loading={isRemediating}
      />
    </div>
  );
};

export default AffectedDevices;